import { ActionKey, ItemMenuProps, MenuItem } from '../Types'
import { useRemovable } from './hooks/useRemovable'
import { useItemContextMenu } from './hooks/useItemContextMenu'
import { useEditable } from './hooks/useEditable'
import { useLinkable } from './hooks/useLinkable'
import { useCopyable } from './hooks/useCopyable'
import { useHandbookItems } from 'components/Handbook2_0/Sidebar/HandbookItemProvider'
import { BaseMenu } from '../BaseMenu'

export const LinkItemMenu = ({ item, onEdit, ...props }: ItemMenuProps) => {
  const { removable, handleRemove } = useRemovable(item, 'Delete URL link')
  const { editable, handleEdit } = useEditable(item, 'Edit URL link', onEdit)
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { linkable, handleLinkable } = useLinkable(item.url!, {
    copyLink: 'Copy link to URL',
  })
  const { copyable, handleCopy } = useCopyable(item, 'Duplicate URL link')
  const { visible, setVisible, handleAction } = useItemContextMenu({
    handlers: [handleRemove, handleEdit, handleLinkable, handleCopy],
  })
  const { currentHandbook: handbook } = useHandbookItems()

  const disabledKeys = new Set<ActionKey>()
  if (handbook?.current_user_access && ['read', 'comment'].includes(handbook.current_user_access)) {
    disabledKeys.add(ActionKey.delete)
    disabledKeys.add(ActionKey.edit)
  }

  const menus: MenuItem[][] = [[linkable.newTab], [linkable.copyLink, ...copyable, ...editable, ...removable]]

  return (
    <>
      <BaseMenu
        menus={menus}
        handleAction={handleAction}
        visible={visible}
        setVisible={setVisible}
        item={item}
        {...props}
      />
    </>
  )
}
